import { useEffect } from 'react';

/**
 * Per-route document title + meta description for the SPA.
 * Pass the full title string; it is set verbatim (no suffix magic).
 * Description is optional — when omitted, the existing description stands.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute('content', description);
    }
  }, [title, description]);
}
